<template>
  <nav id="header-nav-main">
    <ul class="nav nav-pills" id="mainNav">
      <li v-for="node in getNav"
          class="dropdown dropdown-mega"
          :class="{hover:isHover(node.id)}"
          :key="node.id"
          @mouseenter="enterHover(node.id)"
          @mouseleave="leaveHover(node.id)">
        <a class="dropdown-toggle" :href="$catLink(node.seo_link)">{{ node.name
          }}</a>
        <ul class="dropdown-menu">
          <li>
            <div class="dropdown-mega-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <template v-for="row in getRows(node.menus)">
                      <div v-for="subnode in getRow(row,node.menus)"
                           class="col-md-3"
                           :key="subnode.id">
                        <a :href="$catLink(subnode.seo_link)"
                           class="dropdown-mega-sub-title">{{ subnode.name
                          }}</a>

                        <ul v-if="subnode.menus.length > 0"
                            class="dropdown-mega-sub-nav">
                          <li v-for="submenu in getLimited(subnode.menus)"
                              :key="submenu.id">
                            <a
                                :href="$catLink(submenu.seo_link)">{{
                              submenu.name }}</a>
                          </li>
                          <li v-if="subnode.menus.length > 5">
                            <a :href="$catLink(subnode.seo_link)"><strong>View
                              all {{subnode.name }}...</strong></a>
                          </li>
                        </ul>
                      </div>
                      <div class="clearfix"></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <slot></slot>
    </ul>
  </nav>
</template>

<script>
  import {mapGetters} from 'vuex'
  import _range from 'lodash-es/range'
  const ROWS = 4
  export default {
    name: 'header-nav-main',
    computed: {
      ...mapGetters([
        'getNav'
      ])
    },
    data(){
      return {
        hoverTab:null,
        hoverEnter:null,
      }
    },
    methods: {
      isHover(id){
        return this.hoverTab === id
      },
      enterHover(id){
        this.hoverEnter=id
        setTimeout(()=>this.addHover(id), 300)
      },
      addHover(id){
        if(this.hoverEnter === id){
          this.hoverTab = id
        }
      },
      leaveHover(id){
        this.hoverEnter=null
        this.hoverTab=null
      },
      getLimited(arr, count = 5) {
        let temp = Array.from(arr).slice(0, count)
        return temp
      },
      getRows(menus) {
        return _range(0, Math.ceil(menus.length / ROWS))
      },
      getRow(row, menus){
        let start = row*ROWS
        return menus.slice(start, start+ROWS)
      }
    },
  }
</script>

<style scoped>
  .sticky-header-active #header .header-nav-main nav {
    background-color: #f0f0ed;
  }
</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/header-nav-main.vue